export const subjectSchoolSystem = {
  // 國文
  '5a4378e49a3a8503133ff104': ['5a43786d9a3a8503133ff100', '5a43788e9a3a8503133ff101', '5a4378a19a3a8503133ff102'],
  // 英文
  '5a4379009a3a8503133ff105': ['5a43786d9a3a8503133ff100', '5a43788e9a3a8503133ff101', '5a4378a19a3a8503133ff102'],
  // 數學
  '5a4379139a3a8503133ff106': ['5a43786d9a3a8503133ff100', '5a43788e9a3a8503133ff101', '5a4378a19a3a8503133ff102'],
  // 理化
  '5a4379379a3a8503133ff107': ['5a43788e9a3a8503133ff101'],
  // 物理
  '5a43794e9a3a8503133ff108': ['5a4378a19a3a8503133ff102'],
  // 化學
  '5a4379649a3a8503133ff109': ['5a4378a19a3a8503133ff102'],
  // 生物
  '5a43798a9a3a8503133ff10a': ['5a43788e9a3a8503133ff101', '5a4378a19a3a8503133ff102'],
  // 地球科學
  '5a4379a79a3a8503133ff10b': ['5a43788e9a3a8503133ff101', '5a4378a19a3a8503133ff102'],
  // 地理
  '5a4379c69a3a8503133ff10d': ['5a43788e9a3a8503133ff101', '5a4378a19a3a8503133ff102'],
  // 歷史
  '5a4379df9a3a8503133ff10e': ['5a43788e9a3a8503133ff101', '5a4378a19a3a8503133ff102'],
  // 公民
  '5a4379f99a3a8503133ff10f': ['5a43788e9a3a8503133ff101', '5a4378a19a3a8503133ff102'],
  // 自然
  '5a437a199a3a8503133ff110': ['5a43786d9a3a8503133ff100'],
  // 社會
  '5a437a349a3a8503133ff111': ['5a43786d9a3a8503133ff100']
};